<template>
    <div class="app-websession-tariff-modal" v-if="isVisible">
        <b-modal
        ref="websession-tariff-modal"
        id="websession-tariff-modal"
        :modal-class="['websession-tariff-modal-info']"
        size="xl"
        data-qa="modal"
        body-bg-variant="custom"
        body-text-variant="custom"
        footer-bg-variant="custom"
        footer-text-variant="custom"
        ok-only ok-title="Schließen"
        hide-header
        @ok="hideModal()"
        >
            <div class="modal-description"><slot name="longTxt"></slot></div>
        </b-modal>
    </div>
</template>

<script>

function cookieExists () {
  return (document.cookie.match(/^(.*;)?\s*hide_websession_tariff_modal\s*=\s*[^;]+(.*)?$/))
}

export default {
  name: 'WebSessionTariffModal',
  components: {},
  data () {
    return {
      isVisible: true
    }
  },
  methods: {
    showModal () {
      if (!cookieExists()) {
        this.$refs['websession-tariff-modal'].show()
      }
    },
    hideModal () {
      this.$refs['websession-tariff-modal'].hide()
      document.cookie = 'hide_websession_tariff_modal=true; max-age=2628000' // expires after one month
      this.isVisible = false
    }
  },
  mounted () {
    this.showModal()
  }
}
</script>
